import { StateController } from "@aceroll/core";
class CheckBalanceController extends StateController {
    constructor() {
        super("check.balance");
    }

    async onStart() {
        this.stop();
    }

    onStop() {
    }
}

export default CheckBalanceController;